import api from "../utils/api";

export const getProjectList = async (category: string, currentPage: number, elementsByPage: number, search: string) => {
    try {
        const baseFilter: any = {
            isPublic: true,
            isVerified: true,
        };

        if (category !== '') {
            baseFilter.categories = {
                title: {
                    $eq: category,
                },
            };
        }

        if (search !== '') {
            baseFilter.$and = [
                {
                    title: {
                        $containsi: search,
                    },
                },
            ];
        }

        const params: any = {
            populate: '*',
            sort: 'createdAt:desc',
            filters: baseFilter,
            pagination: {
                limit: elementsByPage,
                start: currentPage,
            },
        };

        const res = await api.get(`/api/projects`, {params});
        return res.data;

    } catch (e) {
        console.error(e);
        throw e;
    }
}

export const getCategories = async () => {
    try {        
        const res = await api.get(`/api/categories`);
        return res.data.data;

    } catch (e) {
        console.error(e);
        throw e;
    }
}

export const toggleLikeProject = async (project: project, userId: number) => {
    try {
        const alreadyLiked = project.likes?.some(item => item.id === userId);

        const likeUpdate = alreadyLiked 
            ? { disconnect: [userId] }
            : { connect: [userId] };

        const res = await api.put(`/api/projects/${project.documentId}`, {
            data: {
                likes: likeUpdate
            }
        });

        return res;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export const downloadProject = async (fileUrl: string, fileName: string) => {
    try {
        const res = await api.get(`${fileUrl}`, {
            responseType: 'blob'
        });

        const fileURL = window.URL.createObjectURL(new Blob([res.data]));

        const fileLink = document.createElement('a');
        fileLink.href = fileURL;

        fileLink.setAttribute('download', fileName);

        document.body.appendChild(fileLink);
        fileLink.click();

        document.body.removeChild(fileLink);
        
        return res;

    } catch (e) {
        console.error(e);
        throw e;
    }
}